import { Column, Editing, Item, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';
const AracMarkalari = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    let skipValidationCheck = false;
    const ref = useRef();
    const mountedRef = useRef(true); // Add mounted ref
    useEffect(() => {
        fetchBrands();

        return () => {
            mountedRef.current = false;
        };
        //eslint-disable-next-line
    }, []);

    const fetchBrands = async () => {
        try {
            const response = await api.post("/getAllBrands");
            if (mountedRef.current) {
                setDataSources(_.orderBy(response.data.data,
                    ['id'], ['asc']) || []);

            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Markalar getirilirken hata oluştu') + ":" + errorMessage);
            console.error("Error fetching brands:", error);
        }
    };

    const createBrandCode = (data) => {
        let str = "" + data;
        let pad = "0000000";
        let ans = pad.substring(0, pad.length - str.length) + str;
        return ans;

    }



    const addBrand = async (newData, e) => {

        let brandCode = dataSources?.length > 0 ? createBrandCode(Number(_.orderBy(dataSources, ['id'], ['desc'])[0].brand_code) + 1) : "0000001"
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = {
            ...newData, is_active: true, create_user_id: employeeId,
            brand_code: brandCode
        };

        try {
            const response = await api.post("/createBrand", body);
            if (response.status === 200 && mountedRef.current) {
                skipValidationCheck = true;
                e.component.saveEditData();
                toast.success(t('Marka başarıyla eklendi'));
                fetchBrands();
            }
        } catch (error) {
            let errorMessage = error.response.data.error || "";
            toast.error(t('Marka eklenirken hata oluştu') + ":" + errorMessage);
            console.error("Error adding brand:", error);
        }
    };
    const updateBrand = async (data, e) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };

        try {
            const response = await api.post("/updateBrand", body);
            if (response.status === 200 && mountedRef.current) {
                skipValidationCheck = true;
                e.component.saveEditData();
                toast.success(t('Marka başarıyla güncellendi'));
                fetchBrands();
            }
        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Marka güncellenirken hata oluştu') + ":" + errorMessage);
            console.error("Error updating brand:", error);
        }
    };


    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addBrand(e.newData, e);
            } else {
                updateBrand(e, e);
            }
        }
    };

    return (
        <>
            <Breadcrumb current={t("Otomobil Markaları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="row"
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column
                        dataField="brand_code"
                        caption={t("Kodu")}
                        alignment="center"
                        selectedFilterOperation="contains"
                        allowEditing={false}
                        cellRender={(data) => {
                            if (data.text === "") {
                                return <i>OTOMATİK</i>
                            } else return <>{data.data.brand_code}</>
                        }}
                    />
                    <Column
                        dataField="brand_name"
                        caption={t("Marka Adı")}
                        alignment="center"
                        selectedFilterOperation="contains"
                    >
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="is_active"
                        caption={t("Geçerli")}
                        alignment="center"
                        selectedFilterOperation="contains"

                    >

                    </Column>
                    <Toolbar>
                        <Item name="groupPanel" location="before" />
                        <Item location="after">
                            <RxButton
                                color='light'
                                outline
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd",
                                }}
                                onClick={fetchBrands}>
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                        </Item>
                        <Item name="addRowButton" location="after" />
                        <Item location="after" >
                            <RxButton
                                color='success'
                                onClick={(e) => ButtonOnExporting(
                                    e,
                                    ref,
                                    "Araç Markaları",
                                    "Sayfa-1"
                                )}
                                style={{ paddingInline: "10px", color: "white" }}
                            >
                                <i className='fa fa-file-excel-o'></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};

export default AracMarkalari;